export default __webpack_public_path__ + "locales/ru/MainBar.json?hash=57460c7b3c2e8e58ce2d4de6d69fd1f9";